/*
 * @Author:JY WANG
 * @Date: 2020-04-07 11:48:43
 * @LastEditTime: 2020-11-18 17:32:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /club/src-client/redux/reducer/index.ts
 */
import { combineReducers } from 'redux';
import postUI from './post/ui';
import postBaseInfo from './post/baseInfo';
import postContent from './post/content';

export default combineReducers({
    postBaseInfo,
    postContent,
    postUI,
});
